import { render, staticRenderFns } from "./LikedProducts.vue?vue&type=template&id=837fa04c&scoped=true&"
import script from "./LikedProducts.vue?vue&type=script&lang=js&"
export * from "./LikedProducts.vue?vue&type=script&lang=js&"
import style0 from "./LikedProducts.vue?vue&type=style&index=0&id=837fa04c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "837fa04c",
  null
  
)

export default component.exports